import { ReactNode } from 'react';
import clsx from 'clsx';
import { Typography } from '../typography';
import { capitalizeFirstLetter } from '@/lib';
import { StatusCase, StatusTypes } from '@/interfaces';
import { END_STATUSES_CASE } from '@/const/cases';

interface Props {
	trigger: ReactNode;
	status: StatusTypes;
	stepName: StatusCase;
	percent?: number;
}

export const TooltipStatus: React.FC<Props> = ({
	trigger,
	status,
	stepName,
	percent,
}) => {
	const formattedName = (): string => {
		return capitalizeFirstLetter(stepName?.replaceAll('-', ' '));
	};

	// const getAlignment = (): 'center' | 'start' | 'end' | undefined => {
	// 	if (typeof percent === 'number') {
	// 		if (percent < 21) return 'start';
	// 		if (percent > 90) return 'end';
	// 	}

	// 	return 'center';
	// };

	// const getOffset = (): number | undefined => {
	// 	if (typeof percent === 'number') {
	// 		if (percent < 11) return -10;
	// 		if (percent < 21) return 50;
	// 		if (percent > 90) return 60;
	// 	}
	// 	return undefined; // Default case
	// };

	const getOffset = (): number | undefined => {
		if (typeof percent === 'number') {
			if (percent < 11) return 0;
			if (percent > 10 && percent < 21) return 0;
			if (percent > 20 && percent < 31) return 10;
			if (percent > 30 && percent < 41) return 23;
			if (percent > 40 && percent < 51) return 30;
			if (percent > 50 && percent < 61) return 40;
			if (percent > 60 && percent < 71) return 50;
			if (percent > 70 && percent < 81) return 60;
			if (percent > 80 && percent < 91) return 70;
			if (percent > 90) return 80;
		}
		return undefined; // Default case
	};

	const getOffsetArrow = (): number | undefined => {
		if (typeof percent === 'number') {
			if (percent < 11) return 15;
			if (percent > 10 && percent < 21) return 34;
			if (percent > 20 && percent < 31) return 36;
			if (percent > 30 && percent < 41) return 42;
			if (percent > 40 && percent < 51) return 38;
			if (percent > 50 && percent < 61) return 45;
			if (percent > 60 && percent < 71) return 40;
			if (percent > 70 && percent < 81) return 38;
			if (percent > 80 && percent < 91) return 40;
			if (percent > 90) return 46;
		}
		return undefined; // Default case
	};

	// const grayStatus: StatusCase[] = [
	// 	'Application in review',
	// 	'Payment details',
	// 	'Case resolved',
	// 	'Accept settlement',
	// ];
	// const blueStatus: StatusCase[] = [
	// 	'Sign retainer',
	// 	'Documents required',
	// 	'Case in progress',
	// 	'Application approved',
	// 	'Case initiated',
	// 	'Review complaint',
	// 	'Claim submitted',
	// ];

	const showBlueTooltip =
		!END_STATUSES_CASE.includes(status) &&
		(status === 'Action Required' || formattedName() === 'Documents required');
	return (
		<div>
			<div>{trigger}</div>

			<div
				className="absolute -top-12"
				// style={{ left: `calc(${percent || 0}% - ${getOffset()}px)` }}
				style={{ left: `${getOffset()}%` }}
			>
				<div
					// align={getAlignment()}
					// alignOffset={getOffset()}
					className={clsx(
						'rounded-lg flex items-center p-2 gap-1 border-none shadow-none w-fit',
						{
							'bg-gray-5': status !== 'Action Required',
							'bg-blue-10': showBlueTooltip,
						}
					)}
				>
					{/* {stepName === 'Sign retainer' && (
							<CircleAlert className="stroke-blue-link w-4 h-4" />
						)} */}
					<Typography
						type="regular-12"
						className={clsx('font-normal text-center whitespace-nowrap', {
							'text-blue-link': showBlueTooltip,
						})}
					>
						{formattedName()}
					</Typography>
				</div>
				<div
					className="absolute -bottom-[7px]"
					style={{ left: `${getOffsetArrow()}%` }}
				>
					{/* arrow down */}
					<svg
						width="13"
						height="12"
						viewBox="0 0 13 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							x="6.5"
							width="8"
							height="8"
							transform="rotate(45 6.5 0)"
							// fill={clsx('#F4F4F4', {
							// 	'#F4F4F4': status !== 'Action Required',
							// 	'#F0F1FF': showBlueTooltip,
							// })}
							fill={showBlueTooltip ? '#F0F1FF' : '#F4F4F4'}
						/>
					</svg>
				</div>
			</div>
		</div>
	);
};
